var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFvBackRight01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 343,
    viewBox: "0 0 480 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.875 180.143L378.231 219.409C378.912 220.846 379.705 222.224 380.616 223.535L417.275 181.987C415.89 181.262 414.416 180.647 412.882 180.143H412.875Z",
    fill: "#C7CFE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M402.031 178.787L375.535 208.816C375.646 210.787 375.949 212.72 376.453 214.594L407.875 178.987C405.912 178.713 403.957 178.654 402.031 178.787Z",
    fill: "#C7CFE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376.616 199.32C376.423 199.987 376.268 200.654 376.12 201.328L394.675 180.298C386.231 183.232 379.29 190.076 376.616 199.32Z",
    fill: "#C7CFE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M431.571 199.891L400.149 235.498C402.112 235.772 404.067 235.831 405.993 235.698L432.489 205.669C432.378 203.698 432.074 201.765 431.571 199.891Z",
    fill: "#C7CFE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M421.134 184.432L383.512 227.068C384.549 228.15 385.683 229.15 386.897 230.061L424.519 187.424C423.475 186.343 422.349 185.343 421.134 184.432Z",
    fill: "#C7CFE4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M413.356 234.187C421.8 231.253 428.741 224.409 431.415 215.165C431.608 214.498 431.763 213.831 431.911 213.157L413.356 234.187Z",
    fill: "#C7CFE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M427.415 190.95L390.756 232.497C392.142 233.223 393.616 233.838 395.149 234.342L429.793 195.076C429.111 193.639 428.319 192.261 427.408 190.95H427.415Z",
    fill: "#C7CFE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M259 111.32C259 114.636 256.315 117.32 253 117.32C249.684 117.32 247 114.636 247 111.32C247 108.004 249.684 105.32 253 105.32C256.315 105.32 259 108.004 259 111.32Z",
    fill: "#C7CFE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M373.5 161.32C374.88 161.32 376 160.201 376 158.82C376 157.44 374.88 156.32 373.5 156.32C372.119 156.32 371 157.44 371 158.82C371 160.201 372.119 161.32 373.5 161.32Z",
    fill: "url(#paint0_linear_685_5649)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M460 6.32032C460 9.6363 457.315 12.3203 454 12.3203C450.684 12.3203 448 9.6363 448 6.32032C448 3.00433 450.684 0.320312 454 0.320312C457.315 0.320312 460 3.00433 460 6.32032Z",
    fill: "#C7CFE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M368 18.3203C369.656 18.3203 371 17.201 371 15.8203C371 14.4396 369.656 13.3203 368 13.3203C366.343 13.3203 365 14.4396 365 15.8203C365 17.201 366.343 18.3203 368 18.3203Z",
    fill: "#C7CFE4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M477 183.32C478.656 183.32 480 182.201 480 180.82C480 179.44 478.656 178.32 477 178.32C475.343 178.32 474 179.44 474 180.82C474 182.201 475.343 183.32 477 183.32Z",
    fill: "#C7CFE4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M477 342.32C478.656 342.32 480 341.201 480 339.82C480 338.44 478.656 337.32 477 337.32C475.343 337.32 474 338.44 474 339.82C474 341.201 475.343 342.32 477 342.32Z",
    fill: "#C7CFE4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4995 326.32C50.8802 326.32 51.9995 325.201 51.9995 323.82C51.9995 322.44 50.8802 321.32 49.4995 321.32C48.1188 321.32 46.9995 322.44 46.9995 323.82C46.9995 325.201 48.1188 326.32 49.4995 326.32Z",
    fill: "#C7CFE4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M413.499 65.3203C415.985 65.3203 418 63.3056 418 60.8203C418 58.335 415.985 56.3203 413.499 56.3203C411.014 56.3203 409 58.335 409 60.8203C409 63.3056 411.014 65.3203 413.499 65.3203Z",
    fill: "#C7CFE4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M313 235.32C315.761 235.32 318 233.082 318 230.32C318 227.559 315.761 225.32 313 225.32C310.238 225.32 308 227.559 308 230.32C308 233.082 310.238 235.32 313 235.32Z",
    fill: "#C7CFE4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4995 148.32C54.8802 148.32 55.9995 147.201 55.9995 145.82C55.9995 144.44 54.8802 143.32 53.4995 143.32C52.1188 143.32 50.9995 144.44 50.9995 145.82C50.9995 147.201 52.1188 148.32 53.4995 148.32Z",
    fill: "#C7CFE4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49951 217.32C3.88023 217.32 4.99951 216.201 4.99951 214.82C4.99951 213.44 3.88023 212.32 2.49951 212.32C1.1188 212.32 -0.000488281 213.44 -0.000488281 214.82C-0.000488281 216.201 1.1188 217.32 2.49951 217.32Z",
    fill: "url(#paint1_linear_685_5649)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.5 194.32C178.88 194.32 180 192.977 180 191.32C180 189.663 178.88 188.32 177.5 188.32C176.119 188.32 175 189.663 175 191.32C175 192.977 176.119 194.32 177.5 194.32Z",
    fill: "#C7CFE4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 194.32C13.8802 194.32 14.9995 192.977 14.9995 191.32C14.9995 189.663 13.8802 188.32 12.4995 188.32C11.1188 188.32 9.99951 189.663 9.99951 191.32C9.99951 192.977 11.1188 194.32 12.4995 194.32Z",
    fill: "#C7CFE4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9995 290.32C98.2086 290.32 99.9995 288.529 99.9995 286.32C99.9995 284.111 98.2086 282.32 95.9995 282.32C93.7904 282.32 91.9995 284.111 91.9995 286.32C91.9995 288.529 93.7904 290.32 95.9995 290.32Z",
    fill: "#C7CFE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_685_5649",
    x1: 371,
    y1: 158.82,
    x2: 376,
    y2: 158.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_685_5649",
    x1: -0.000488281,
    y1: 214.82,
    x2: 5.00684,
    y2: 214.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C44A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFvBackRight01);
export default __webpack_public_path__ + "static/media/fv-back__right01.90a7e5acffabd22d0ebd99b66dedbee1.svg";
export { ForwardRef as ReactComponent };